import { render, staticRenderFns } from "./QuestionBankTitles.vue?vue&type=template&id=87e62ed2&"
import script from "./QuestionBankTitles.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports